import {applyMiddleware, createStore} from 'redux'
import rootReducer from "./redux/reducers/rootReducer";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { loadFromLocalStorage ,saveToLocalStorage} from '../src/redux/actions/userActions';
 const persistant = loadFromLocalStorage()
export const store = createStore(rootReducer, persistant,composeWithDevTools(applyMiddleware(thunk)))
store.subscribe(() => saveToLocalStorage(store.getState()));
